import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { errMsg } from "@/lib/api";
import { usePortalAuth } from "@/context/PortalAuthContext";
import { LegalLinks } from "@/components/LegalLinks";

export function PortalAuthCard({ title, subtitle, children, brand }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12">
      <div className="w-full max-w-sm space-y-6 rounded-xl border border-slate-200 bg-white p-8 shadow-sm fade-up" style={{ borderTop: `4px solid ${brand || "#13294B"}` }}>
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>
        {children}
        <LegalLinks testId="portal-legal-links" className="justify-center border-t border-slate-100 pt-4" />
      </div>
    </div>
  );
}

export default function PortalLogin() {
  const { account, login } = usePortalAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (account) return <Navigate to="/portal" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(f.email, f.password); navigate("/portal"); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <PortalAuthCard title="Client portal" subtitle="Track your print jobs, approve proofs and view invoices.">
      <form onSubmit={submit} className="space-y-4" data-testid="portal-login-form">
        <Input data-testid="portal-login-email" type="email" placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required />
        <PasswordInput data-testid="portal-login-password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
        {error && <p data-testid="portal-login-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
        <Button data-testid="portal-login-submit" type="submit" disabled={busy} className="w-full bg-[#13294B] hover:bg-[#1c3a66]">{busy ? "Signing in…" : "Sign in"}</Button>
        <p className="text-xs text-slate-400">Your printer sends you an invite to set your password. Staff sign in <Link to="/login" className="underline">here</Link>.</p>
      </form>
    </PortalAuthCard>
  );
}
